import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, stopSubmit, FieldArray } from "redux-form";
import { Form, FormGroup, Label, Alert, Button } from "reactstrap";

import TextInput from "../../system/fields/TextInput";
import SelectDropdown from "../../system/fields/SelectDropdown";
import FileUpload from "../../system/fields/FileUpload";
import StarRating from "../../system/fields/StarRating";
import SectionWrapper from "./components/SectionWrapper";

import * as validations from "../../system/utils/Validation";
import { getCities, getDealTypes, getCountries } from "../../store/overview";
import Wysiwyg from "../../system/fields/Wysiwyg";

const BlogItem = ({ fields }) => {
  return (
    <div className={"repeater-container"}>
      {fields.map((section, i) => (
        <SectionWrapper section={section} fields={fields} index={i} key={i} />
      ))}
      <div className={"add-button bottom"}>
        <Button
          type={"button"}
          onClick={() => fields.push({ section_type: "" })}
        >
          Add Section
        </Button>
      </div>
    </div>
  );
};

class EditForm extends React.Component {
  componentDidMount() {
    this.props.dispatch(getDealTypes());
    this.props.dispatch(getCities());
    this.props.dispatch(getCountries());
  }

  render() {
    const { props } = this;
    const { handleSubmit, mode } = props;
    return (
      <section className="edit-form">
        <Form onSubmit={handleSubmit}>
          <section className="form-section">
            <div className={"row"}>
              <FormGroup className={"col-12"}>
                <Label>Title</Label>
                <Field
                  name={"title"}
                  component={TextInput}
                  type={"text"}
                  validate={validations.required}
                />
              </FormGroup>
              <FormGroup className={"col-12 col-sm-4"}>
                <Label>Cities</Label>
                <Field
                  name={"destinations"}
                  component={SelectDropdown}
                  multi
                  labelKey={"label"}
                  valueKey={"id"}
                  options={props.cities}
                  validate={validations.required}
                />
              </FormGroup>
              <FormGroup className={"col-sm-4"}>
                <Label>Countries</Label>
                <Field
                  name={"countries"}
                  component={SelectDropdown}
                  multi
                  labelKey={"value"}
                  valueKey={"id"}
                  options={props.countries}

                />
              </FormGroup>
              <FormGroup className={"col-12 col-sm-4"}>
                <Label>Deal Type</Label>
                <Field
                  name={"deal_types"}
                  component={SelectDropdown}
                  multi
                  labelKey={"name"}
                  valueKey={"id"}
                  options={props.dealTypes}
                  validate={validations.required}
                />
              </FormGroup>
              <FormGroup className={"col-12"}>
                <Label>Excerpt</Label>
                <Field
                  name={"excerpt"}
                  component={Wysiwyg}
                  className={"w-100 form-control"}
                  maxlength={"200"}
                  style={{
                    minHeight: 150,
                    height: 'auto'
                  }}
                  type={"text"}
                  validate={[validations.required, validations.maxLength150]}
                />
              </FormGroup>
              <FormGroup className={"col-12"}>
                <Label>Banner Image</Label>
                <Field
                  name={"banner_image"}
                  component={FileUpload}
                  validate={validations.required}
                />
              </FormGroup>
            </div>
            <div className={"row"}>
              <FormGroup className={"col-12"}>
                <FieldArray
                  name={"blog"}
                  component={BlogItem}
                  validate={validations.required}
                />
              </FormGroup>
            </div>
          </section>
        </Form>

        {props.submitFailed && (
          <div className="error-container">
            <Alert color="danger">
              <strong>There are errors in your form.</strong>
              <br />Please check before submitting again.
            </Alert>
          </div>
        )}
      </section>
    );
  }
}

EditForm = reduxForm({
  form: "BlogForm",
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) {
      dispatch(stopSubmit("BlogForm"));
    }
  }
})(EditForm);

const mapStateToProps = state => ({
  dealTypes: state.overview.dealTypes,
  cities: state.overview.cities,
  countries: state.overview.countries
});

export default connect(mapStateToProps)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/Blogs/Form.jsx